export type BannerPdfImageData = {
  imageBase64: string;
  mimeType?: string;
  width?: number;
  height?: number;
};

/**
 * Wraps the exported banner raster in a single-page PDF (print / email friendly).
 */
export const downloadBannerAsPdf = async (
  imageData: BannerPdfImageData,
  fileName: string,
): Promise<void> => {
  const { jsPDF } = await import('jspdf');

  const width = Math.max(1, Math.round(Number(imageData.width) || 1));
  const height = Math.max(1, Math.round(Number(imageData.height) || 1));
  const imageFormat = imageData.mimeType?.includes('png') ? 'PNG' : 'JPEG';

  const pdf = new jsPDF({
    orientation: width >= height ? 'landscape' : 'portrait',
    unit: 'px',
    format: [width, height],
    compress: true,
  });

  pdf.addImage(
    imageData.imageBase64,
    imageFormat,
    0,
    0,
    width,
    height,
    undefined,
    'FAST',
  );
  pdf.save(fileName);
};

export default downloadBannerAsPdf;
